import { createFileRoute } from '@tanstack/react-router'
import { TemplateVersionDetailPage } from '@/features/admin/templates/detail/version-detail'

export const Route = createFileRoute(
  '/_admin/admin/templates/$templateId/version/$versionId/'
)({
  component: TemplateVersionDetailPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      edit: search.edit === true || search.edit === 'true',
    }
  },
})
